import { Link } from "react-router-dom";

/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* COMPONENTS */
import ContactForm from "components/contact-form";

/* ICONS */
import {
  IoCall,
  IoMail,
  IoLogoFacebook,
  IoLogoInstagram,
} from "react-icons/io5";

const Footer = () => {
  return (
    <motion.footer variants={animation} className="bg-black" id="contact">
      {/* CONTACT US FORM */}
      <div className="py-0">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20 py-6 xl:py-12 lg:py-12 border-b border-white border-opacity-30 items-center">
            <div className="col-span-1">
              <h5 className="text-lg font-source font-medium text-red-300">
                CONTACT US
              </h5>
              <h2 className="mt-5 text-2xl font-source font-bold text-white leading-snug">
                Get in touch with us – We&apos;re here to support your training
                journey every step of the way
              </h2>
              <h5 className="mt-5 text-base font-source font-normal text-white text-opacity-65 leading-relaxed">
                We understand that everyone learns differently, therefore we
                designed a few pre-licensing real estate courses with various
                learning styles in mind. Reach out today and start your journey
                towards real estate industry success.
              </h5>
            </div>
            <div className="col-span-1">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT DETAILS */}
      <div className="py-5 xl:py-8 lg:py-8">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 items-center">
            <div className="col-span-1">
              <h5 className="text-xl font-source font-bold text-white tracking-tight">
                Connect with us
              </h5>
              <p className="text-sm font-source font-normal text-white text-opacity-80">
                Connect with us to know about how our team can help you
              </p>
            </div>
            <div className="col-span-2 mt-5 xl:mt-0 lg:mt-0">
              <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-0 lg:gap-0 items-center">
                <div className="col-span-1">
                  <div className="flex items-center gap-5 group cursor-pointer">
                    <div className="w-12 h-12 bg-[#232327] rounded-full shrink-0 flex items-center justify-center">
                      <IoCall className="w-5 h-5 text-white group-hover:text-red-300 transition-all duration-300 ease-in-out" />
                    </div>
                    <div>
                      <h5 className="text-sm font-source font-normal text-white text-opacity-80">
                        Give us a call
                      </h5>
                      <a
                        href="tel:+15622159611"
                        className="block text-base font-source font-normal text-white group-hover:text-red-300 transition-all duration-300 ease-in-out tracking-tight"
                      >
                        +1 (562) 202-3427
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-span-1">
                  <div className="flex items-center gap-5 group cursor-pointer">
                    <div className="w-12 h-12 bg-[#232327] rounded-full shrink-0 flex items-center justify-center">
                      <IoMail className="w-5 h-5 text-white group-hover:text-red-300 transition-all duration-300 ease-in-out" />
                    </div>
                    <div>
                      <h5 className="text-sm font-source font-normal text-white text-opacity-80">
                        Send us an email
                      </h5>
                      <a
                        href="mailto:surepassbook@gmail.com"
                        className="block text-base font-source font-normal text-white group-hover:text-red-300 transition-all duration-300 ease-in-out tracking-tight"
                      >
                        surepassbook@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-span-1">
                  <div className="flex items-center justify-start xl:justify-end lg:justify-end gap-5">
                    <h5 className="text-sm font-source font-normal text-white text-opacity-80">
                      Follow us on
                    </h5>
                    <div className="flex items-center gap-2">
                      <a
                        href="https://www.facebook.com/profile.php?id=100083301580887"
                        target="_blank"
                        rel="noreferrer"
                        className="w-10 h-10 bg-[#232327] rounded-full flex items-center justify-center text-white hover:text-red-300 transition-all duration-300 ease-in-out flex-shrink-0"
                      >
                        <IoLogoFacebook className="w-5 h-5" />
                      </a>
                      <a
                        href="https://www.instagram.com/dreamforce_academy/"
                        target="_blank"
                        rel="noreferrer"
                        className="w-10 h-10 bg-[#232327] rounded-full flex items-center justify-center text-white hover:text-red-300 transition-all duration-300 ease-in-out flex-shrink-0"
                      >
                        <IoLogoInstagram className="w-5 h-5" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* COPYRIGHT FOOTER */}
      <div className="py-0">
        <div className="container">
          <div className="py-4 block xl:flex lg:flex items-center justify-between border-t border-white border-opacity-30">
            <p className="text-xs font-source font-normal text-white text-opacity-80">
              © Copyright 2025 Dreamforce Academy. All Rights Reserved. Designed
              by{" "}
              <Link
                href="https://www.roundtechsquare.com"
                target="_blank"
                className="text-blue-400"
              >
                RoundTechSquare
              </Link>
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
